import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[addAsteriskIfRequired]',
})
export class AddAsteriskIfRequiredDirective implements OnInit {
  @Input('addAsteriskIfRequired') formControl?: AbstractControl | FormControl | null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const control = this.formControl;
    if (!control || !control.validator) return;

    const validator = control.validator({} as any);
    const isRequired = validator && validator['required'] !== undefined;

    if (isRequired) {
      const label = this.el.nativeElement;

      if (!label.querySelector('.required-star')) {
        const star = this.renderer.createElement('span');
        this.renderer.addClass(star, 'required-star');
        this.renderer.setStyle(star, 'margin-left', '4px');
        const starText = this.renderer.createText('*');
        this.renderer.appendChild(star, starText);
        this.renderer.appendChild(label, star);
      }
    }
  }
}
